import { ContentHubData } from "@app/types/ServerCustomContext";
import placeholders from "@pub/placeholders";
import { Card } from "@sphtech/dmg-design-system";

import styles from "./contenthubshadowteasers.module.css";

type Props = {
  data?: Omit<ContentHubData, "metaData">;
};

const ContentHubShadowTeasers = ({ data }: Props) => {
  if (
    !data?.contentHubList?.teasers ||
    data.contentHubList.teasers.length === 0
  ) {
    return null;
  }

  const contentListData = data.contentHubList;

  return (
    <div className={styles.backgroundContainer}>
      <div className={styles.contentContainer}>
        {contentListData.teasers.map((teaser, index) => {
          return (
            <div key={index} className={styles.itemContainer}>
              <Card
                {...teaser}
                variant="card-stacked-original"
                mobileUpVariant="card-stacked-original-mobile-up"
                placeholders={placeholders}
                displayPublishDate={false}
                tags={undefined}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ContentHubShadowTeasers;
